/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
// Language switcher: hover-opens the localization panel in the header and the
// footer, and hands the "change store" row over to the market popup.
//
// The locale buttons inside the panel are plain submits on Shopify's
// {% form 'localization' %}, so switching language needs no JS at all — the
// form posts to /localization with a return_to of the current path. This file
// only handles showing and hiding the panel.
document.addEventListener("DOMContentLoaded", languageSelectorHandler);

function languageSelectorHandler() {
  if (typeof window.jQuery === "undefined") return;

  var $ = window.jQuery;

  // Panels are rendered only when 2+ languages are published, so every lookup
  // below has to tolerate an empty set.
  //
  // Deliberately NOT adding `menu-showing` to the header: that class is for the
  // full mega-menu, which needs the solid header backdrop, and it carries a
  // blanket `header.menu-showing * { color: var(--color-primary-dark) }`. Since
  // the trigger's globe and caret are currentColor, that rule turned them black
  // on hover — and on the floating homepage header the intended solid background
  // never even applied, because `.positioned_top.header` forces
  // `background: transparent !important`. Mirrors handleHelpDropdown() in
  // desk_header-script.js instead: dim the page behind, leave header colours be.
  // The panel reveal itself is CSS (see .header_language-dropdown-wrap). These
  // hooks only drive the shared page overlay, and mirror showShadow/scheduleHide
  // in handleHelpDropdown() — same 300ms fades, same 80ms hide deferral.
  var shadowHideTimer = null;

  bindHoverPanel($("#header__language--selector"), $("#header_desktop-dropdown"), {
    onOpen: function () {
      var $shadow = $(".dropdown-shadow");
      if (!$shadow.length) return;
      clearTimeout(shadowHideTimer);
      // No `:visible` guard here on purpose. Coming straight off another
      // dropdown, the overlay is still visible but that dropdown has a deferred
      // fadeOut queued — skipping the fadeIn left the language panel with no
      // overlay at all. stop(true, true) cancels the in-flight animation.
      $shadow.stop(true, true).fadeIn(300);
      if (typeof window.lockScroll === "function") window.lockScroll();
    },
    onClose: function () {
      var $shadow = $(".dropdown-shadow");
      if (!$shadow.length) return;
      // Deferred by 80ms, exactly like handleHelpDropdown's scheduleHide: the
      // panel closes instantly now, so without this the overlay would flicker
      // while the pointer travels to whichever dropdown is taking over.
      clearTimeout(shadowHideTimer);
      shadowHideTimer = setTimeout(function () {
        // Hand off rather than hide — the megamenu, the help dropdown and this
        // panel all own the same overlay. Reciprocal to the checks those two
        // make in desk_header-script.js. Re-checked here because the pointer may
        // have come back within the 80ms.
        if (otherDropdownHovered() || languagePanelOpen()) return;
        $shadow.stop(true, true).fadeOut(300);
        if (typeof window.unlockScroll === "function") window.unlockScroll();
      }, 80);
    },
  });

  // Footer trigger. Below the drawer breakpoint it stops being a dropdown: the
  // panel is removed by CSS and the trigger opens the mobile menu on its language
  // tab, which is the same screen with room to breathe on a small viewport.
  bindHoverPanel(
    $(".footer_language-switcher_outer_out"),
    $("#footer_desktop-dropdown"),
    {
      disabled: isDrawerBreakpoint,
      interceptClick: function () {
        if (!isDrawerBreakpoint()) return false;
        openMobileLanguageTab();
        return true;
      },
    }
  );

  // Dim-siblings hover on the locale rows, mirroring the megamenu sublist and the
  // help dropdown: hovering a row marks the container so every row dims and only
  // the pointed-at one stays at full opacity. Delegated rather than bound
  // directly (as those two are) so it survives a section re-render in the theme
  // editor; jQuery special-cases delegated mouseenter/mouseleave.
  $(document)
    .on("mouseenter", ".header_language-dropdown-btn", function () {
      $(this).closest(".header_language-dropdown-grid").addClass("hovered");
    })
    .on("mouseleave", ".header_language-dropdown-btn", function () {
      $(this).closest(".header_language-dropdown-grid").removeClass("hovered");
    });

  // "Change store" opens the market/country popup rather than switching language.
  // Two hooks for the same action:
  //   [data-open-store-popup] — the <button> in the desktop header/footer panels
  //   [data-btn-type="changeLan"] — the mobile language screen's footer button,
  //     rendered through the desk_button snippet, which emits the caller's `type`
  //     as data-btn-type. It is an <a href="#">, so the default jump-to-top has
  //     to be suppressed.
  $(document).on(
    "click",
    '[data-open-store-popup], [data-btn-type="changeLan"]',
    function (event) {
      event.preventDefault();
      openStorePopup();
    }
  );

  function bindHoverPanel($trigger, $panel, hooks) {
    if (!$trigger.length || !$panel.length) return;

    var openedAt = 0;
    hooks = hooks || {};

    function open() {
      if (hooks.disabled && hooks.disabled()) return;
      // Stamped only on a real state change: mouseenter also fires for the panel
      // itself while it is already open, and that must not keep pushing the
      // timestamp forward (see the tap guard below).
      if (!$trigger.hasClass("hovered")) openedAt = Date.now();
      $trigger.addClass("hovered");
      $trigger.find(".language--selector__button").attr("aria-expanded", "true");
      if (hooks.onOpen) hooks.onOpen();
    }

    function close() {
      $trigger.removeClass("hovered");
      $trigger.find(".language--selector__button").attr("aria-expanded", "false");
      if (hooks.onClose) hooks.onClose();
    }

    // Hover is bound to the trigger only, and closes immediately — no deferral.
    // The panel is a DOM *descendant* of the trigger (absolutely positioned, but
    // still inside it), so moving the pointer down into it never leaves the
    // trigger. That is exactly how .desk_header-help-dropdown sits inside
    // .desk_header-nav__item.has-help-dropdown, and it is why that dropdown can
    // be pure CSS :hover. A deferred close here made the panel linger ~250ms
    // after the pointer left, which is what read as a different animation.
    $trigger.on("mouseenter", open);
    $trigger.on("mouseleave", close);

    // Tap/click, bound to the whole trigger rather than to a specific button
    // class: the header trigger is a <button> but the footer one is a plain div,
    // and on touch there is no hover at all — without this the footer switcher
    // could not be opened on a phone. Clicks originating inside the panel are
    // ignored so choosing a locale (or opening the store popup) doesn't collapse
    // the panel underneath the tap.
    //
    // It is deliberately NOT a plain toggle. Hover and click share the `hovered`
    // state, so a mouse user who hovered the trigger open and then clicked it
    // would have it shut in their face. With a mouse the pointer is what holds
    // the panel open, so a click on an already-open panel does nothing and
    // mouseleave closes it. Only touch, which has no hover to leave, closes on a
    // second tap.
    $trigger.on("click", function (event) {
      if ($(event.target).closest($panel).length) return;
      event.preventDefault();

      // First refusal to the intercept — at the drawer breakpoint the footer
      // trigger opens the mobile menu instead of this panel.
      if (hooks.interceptClick && hooks.interceptClick()) return;

      if (!$trigger.hasClass("hovered")) {
        open();
        return;
      }

      var nativeEvent = event.originalEvent;
      var pointerType = (nativeEvent && nativeEvent.pointerType) || "";
      var isTouch = pointerType === "touch" || pointerType === "pen";

      // Some mobile browsers fire mouseenter before click on the same tap, which
      // would open then immediately close. Ignore the click belonging to the tap
      // that just opened it.
      if (isTouch && Date.now() - openedAt > 400) close();
    });

    // Tapping elsewhere closes it. Needed on touch, where mouseleave — and so
    // scheduleClose — never runs.
    $(document).on("click", function (event) {
      if (!$trigger.hasClass("hovered")) return;
      if ($(event.target).closest($trigger).length) return;
      close();
    });

    $(document).on("keydown", function (event) {
      if (event.key !== "Escape" || !$trigger.hasClass("hovered")) return;
      var hadFocus = $trigger[0].contains(document.activeElement);
      close();
      if (hadFocus) $trigger.find(".language--selector__button").trigger("focus");
    });

    $trigger.on("focusout", function (event) {
      if (event.relatedTarget && !$trigger[0].contains(event.relatedTarget)) close();
    });
  }

  // The other two consumers of .dropdown-shadow, so the overlay survives a
  // hover moving between them and the language panel.
  // 1279px is the theme's drawer breakpoint — the width at which the header swaps
  // .Desktop_only for .Mobile_only and the mobile menu button becomes the way in.
  function isDrawerBreakpoint() {
    return window.innerWidth <= 1279;
  }

  // Opens the mobile drawer with the language tab showing. Triggers the theme's
  // own controls rather than reimplementing them: desk_header-script.js opens the
  // drawer from .desk_header-control__mob-menu and reveals the changeLan panel
  // from .desk_mob-drawer-footer-lang, including the scroll lock.
  function openMobileLanguageTab() {
    var $menuButton = $(".desk_header-control__mob-menu").first();
    if ($menuButton.length) $menuButton.trigger("click");

    var $languageRow = $(".desk_mob-drawer-footer-lang").first();
    if ($languageRow.length) {
      $languageRow.trigger("click");
    } else {
      // The row is gated by the same settings as this trigger, so it should
      // always exist; reveal the tab directly if it somehow doesn't.
      $('.desk_mob-menu-subitem_box[data-attr="changeLan"]').removeClass("hidedMenu").prop("inert", false);
    }
  }

  // Open state is :hover OR the tap-set class, since the reveal is CSS-driven for
  // mouse users and class-driven for touch.
  function languagePanelOpen() {
    var $sel = $("#header__language--selector");
    return $sel.is(":hover") || $sel.hasClass("hovered");
  }

  function otherDropdownHovered() {
    return (
      $(".desk_header-nav__item.has-dropdown").is(":hover") ||
      $(".desk_header-megamenu-outer").is(":hover") ||
      $(".desk_header-nav__item.has-help-dropdown").is(":hover")
    );
  }

  function openStorePopup() {
    var $popup = $('.lp_outer[data-popup="change"]');
    if (!$popup.length) return;
    $("body").addClass("popup-open");
    $popup.css("display", "flex");
    setTimeout(function () {
      $popup.addClass("visible");
    }, 500);
  }
}
